module.exports = __webpack_public_path__ + "img/arrow_large.576c76bb.svg";